import Hero from "@/components/sections/Hero";
import ServicesBento from "@/components/sections/ServicesBento";
import AboutSection from "@/components/sections/AboutSection";
import TeamCarousel from "@/components/sections/TeamCarousel";
import TestimonialsMarquee from "@/components/sections/TestimonialsMarquee";
import ContactForm from "@/components/sections/ContactForm";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <ServicesBento />
      <AboutSection />
      <TeamCarousel />
      <TestimonialsMarquee />
      <ContactForm variant="dark" />
    </div>
  );
}
